<template>
  <el-dialog
    :visible="visible"
    :close-on-click-modal="false"
    title="Карта погрузок"
    width="90%"
    top="5vh"
    custom-class="map-dialog"
    @close="beforeClose"
    @open="beforeOpen"
  >
    <loader-wrapper :loading="isLoading">
      <el-row>
        <el-col :span="19">
          <bids-map-home
            :freights="freightTypesObj"
            :bids="bidsList"
            :selected-coord="selectedCoord"
            @next="handleNextBid"
            @closeBallon="handleCloseBallon"
          />
        </el-col>
        <el-col :span="5" class="map-right">
          <el-autocomplete
            v-model="search"
            size="large"
            :debounce="500"
            :clearable="true"
            class="inline-input-autocomplete"
            :fetch-suggestions="querySearch"
            placeholder="Поиск по месту загрузки"
            @select="handleSelect"
            @clear="onClear"
          />
          <div v-if="bid" class="bid-day-map">
            <bid-day-map
              v-for="b in bid.load_days"
              :key="b.id"
              :doc-info="getDay(b.id)"
              :doc-loading="loadingDays"
              :day="{ ...b, type_code: bid.type_code }"
              :bid-id="bid.id"
              v-on="$listeners"
            />
          </div>
        </el-col>
      </el-row>
    </loader-wrapper>
  </el-dialog>
</template>

<script>
import BidDayMap from '@/views/Home/Shipping/Item/BidDayMap'
import BidsMapHome from '@/components/Maps/BidsMapHome'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

import { mapGetters } from 'vuex'

import { RepositoryFactory } from '@/api/RepositoryFactory'
import { defaultDate } from '@/datas/DateFormats'
import { getNow, isAfterDay } from '@/helpers/date'
const LoadDay = RepositoryFactory.get('loadDay')

export default {
  name: 'BidsOnMap',
  components: { LoaderWrapper, BidsMapHome, BidDayMap },
  props: {
    bidsList: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedCoord: {},
      autocompleteList: [],
      search: '',
      loading: false,
      load_day_id: [],
      docs: [],
      bidFromMap: null,
      loadingDays: false,
    }
  },
  computed: {
    ...mapGetters('bids', ['getLoading', 'getBid']),
    ...mapGetters({
      getLibObj: 'libs/getLibObj',
      getType: 'bids/getTypeCode',
      bids: 'bids/getBids',
      getTypeView: 'bids/getTypeView',
      getUnloadPointKladrId: 'bids/getUnloadPointKladrId',
    }),
    bid() {
      const getTime = date => new Date(date).getTime()
      let list
      let countAuto = 0
      const loadDays = []
      const currentDay = getNow(defaultDate)
      const afterDateMoment = isAfterDay(currentDay)

      if (this.bidFromMap && this.bidFromMap.load_days) {
        this.bidFromMap.load_days.map(d => {
          countAuto += d.responses_count_total

          if (!afterDateMoment(d.load_date)) {
            return false
          }
          loadDays.push(d)
        })
        const sortedLoadDays = loadDays.sort(
          (a, b) => getTime(a.load_date) - getTime(b.load_date),
        )

        list = { ...this.bidFromMap, load_days: sortedLoadDays, countAuto }
      }

      return list ? list : this.bidFromMap
    },

    isLoading() {
      return this.getLoading('Map') || this.loading
    },
    freightTypesObj() {
      return this.getLibObj('freightTypes')
    },
  },
  watch: {
    bidFromMap(val) {
      if (val) {
        this.getDocCount()
      }
    },
    load_days_ids(newVal) {
      this.$emit('handleSelectedLoadDaysIds', newVal)
    },
  },
  methods: {
    handleCloseBallon() {
      if (this.bidFromMap !== null) {
        this.bidFromMap = null
      }
    },
    getDocCount() {
      const ids =
        this.bidFromMap && this.bidFromMap.load_days
          ? this.bidFromMap.load_days.map(b => b.id)
          : []

      if (ids.length) {
        this.loadingDays = true
        LoadDay.getDocCount(ids)
          .then(res => {
            const { status, data } = res

            if (status === 200 && data) {
              this.docs = data
            }
          })
          .catch(() => this.$message.error('Ошибка получения данных'))
          .finally(() => (this.loadingDays = false))
      } else {
        this.docs = []
      }
    },
    getDay(id) {
      return this.docs.find(d => Number(d.load_day_id) === id)
    },
    handleNextBid(bid) {
      this.bidFromMap = bid
      this.load_day_id = []

      bid?.load_days.map(item => this.load_day_id.push(item.id))
    },
    handleSelect(item) {
      this.selectedCoord = item.loading_point
    },
    querySearch(queryString, cb) {
      let links = this.autocompleteList
      let results = queryString
        ? links.filter(this.createFilter(queryString))
        : links

      // call callback function to return suggestions
      cb(results)
    },
    createFilter(queryString) {
      return link =>
        link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
    },

    beforeClose() {
      this.$emit('closed')
      this.search = ''
      this.selectedCoord = {}
    },
    uniq(xs) {
      let seen = {}

      return xs.filter(x => {
        let key = JSON.stringify(x)

        return !(key in seen) && (seen[key] = x)
      })
    },
    onClear() {
      this.selectedCoord = {}
    },

    beforeOpen() {
      this.$emit('fetch', { enablePages: 0 })
      this.bidsList.map(item => {
        this.autocompleteList.push({
          value: item.load_point.substr(item.load_point.indexOf(',') + 1),
          loading_point: item.loading_point,
        })
      })
      this.autocompleteList = this.uniq(this.autocompleteList)
    },
  },
}
</script>

<style lang="sass">
.map-dialog
  overflow: hidden
  height: 100%
  .bid-day-map
    overflow-y: auto
    height: 74vh
  .inline-input-autocomplete
    width: 100%
  .map-right
    padding: 0 0 0 20px
    .map-right-scroll
      height: 70vh
      overflow-y: auto
      display: flex
      flex-direction: column
      .el-radio
        margin-top: 15px
    .el-button
      margin-right: 5px
      &.green
        color: #67c23a
</style>
